import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'

@Injectable({
    providedIn: 'root',
})
export class AuthApiService {
    private readonly baseUrl = environment.apiUrl

    constructor(private readonly http: HttpClient) {}

    login(email: string, password: string): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(`${this.baseUrl}/login`, { email, password })
    }

    logout(): Observable<void> {
        return this.http.post<void>(`${this.baseUrl}/logout`, {})
    }

    getUsername(): Observable<string> {
        return this.http.get<string>(`${this.baseUrl}/username`)
    }
}

type LoginResponse = LoginResponseMessage | string

interface LoginResponseMessage {
    message: string
}
